import Vue from 'vue'
import Cube11 from './Cube11.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(Cube11)
}).$mount('#cube11')
